import React from 'react'; 
import styles from './custom-stats-card.module.css';
import { Typography } from 'antd';
import { LineChart } from 'recharts';

export function CustomStatsCard({
  title,
  value,
  subtitle,
  highlightValue,
  highlightColor,
  chartData = [],
  chartColor = [],
}) {
  const formattedChartData = {
    labels: Array(chartData.length).fill(''),
    datasets: [
      {
        data: chartData,
        borderColor: chartColor,
        backgroundColor: chartColor + '33',
        borderWidth: 2,
        fill: true,
        tension: 0.4,
        pointRadius: 0,
      },
    ],
  };

  return (
    <div className={styles.statsContainer}>
      <div className={styles.dataContainer}>
        <Typography className={styles.title}>{title}</Typography>
        <Typography className={styles.value}>{value}</Typography> 
      </div>
      <div className={styles.chartContainer}>
        <LineChart data={formattedChartData} />
      </div>
    </div>
  );
}

export default CustomStatsCard;
